import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import CustomModal from '../custom_modal';
import Button from '../button';
import RequiredReasonTextarea from '../required_reason_textarea';
import { is_valid_reason, trim_reason } from '../required_reason_textarea/reason_rules';

// Owns the note; parent gets the trimmed reason.
function ReasonNoteModal(props) {
  const { show, close, onConfirm, title, description, placeholder, errorText, confirmLabel } = props;
  const [reason, setReason] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (show) {
      setReason('');
      setError(false);
    }
  }, [show]);

  const confirm = () => {
    if (!is_valid_reason(reason)) {
      setError(true);
      return;
    }
    onConfirm(trim_reason(reason));
  };

  return (
    <CustomModal show={show} close={close}>
      <h5>{title}</h5>
      {description ? <p style={{ margin: '10px 0', maxWidth: '340px' }}>{description}</p> : null}
      <RequiredReasonTextarea
        value={reason}
        onChange={(e) => {
          setReason(e.target.value);
          setError(false);
        }}
        placeholder={placeholder}
        error={error}
        errorText={errorText}
        height="80px"
      />
      <Button onClick={confirm}>{confirmLabel}</Button>
      <Button onClick={close}>Cancel</Button>
    </CustomModal>
  );
}

ReasonNoteModal.propTypes = {
  show: PropTypes.bool,
  close: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  placeholder: PropTypes.string,
  errorText: PropTypes.string,
  confirmLabel: PropTypes.string
};

ReasonNoteModal.defaultProps = {
  show: false,
  description: '',
  placeholder: 'Reason (required)',
  errorText: '',
  confirmLabel: 'Confirm'
};

export default ReasonNoteModal;
